/*
  !IMPORTANT!: This file will be deleted in the future!
  If you want to use this functionality, please rather turn your *.vue file into a composition API and directly use the `useLists` composable instead.
  This file is only kept for backwards compatibility for old *.vue files that are still using options API and mixins.

  If you want to change the branding functionality, please do it in this mixin AND the composable!
*/
import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

const listsMixin = {
  methods: {
    /**
     * Updates the Array with given Item
     * @param array : Array
     * @param itemToSave : Object
     * @param keyToFilterBy : string
     */
    updateItem (array, itemToSave, keyToFilterBy = 'id') {
      if (!Array.isArray(array)) {
        throw new Error('Cant find a valid Array by the given arg: array')
      }

      if (Array.isArray(itemToSave)) {
        return itemToSave.forEach((item) => this.updateItem(array, item, keyToFilterBy))
      }

      const index = array.findIndex(s => s[keyToFilterBy] === itemToSave[keyToFilterBy])

      return Object.values({ ...array, [index]: itemToSave })
    },

    /**
     * Replace the Array with given Item
     * @param array
     * @param itemToSave
     * @param oldItem
     * @param keyToFilterBy
     */
    replaceItem (array, itemToSave, oldItem, keyToFilterBy = 'id') {
      if (!Array.isArray(array)) {
        throw new Error('Cant find a valid Array by the given arg: array')
      }

      const index = array.findIndex(s => s[keyToFilterBy] === oldItem[keyToFilterBy])

      return Object.values({ ...array, [index]: itemToSave })
    },

    /**
   * Deletes an item from Array
   * @param array
   * @param idToDelete
   * @param keyToFilterBy
   */
    deleteItem (array, idToDelete, keyToFilterBy = 'id') {
      if (!Array.isArray(array)) {
        throw new Error('Cant find a valid Array by the given arg: array')
      }
      const filteredArr = array.filter(n => n[keyToFilterBy] !== idToDelete)
      return GlobalPrototypes.clone(filteredArr)
    }
  }
}

export default listsMixin
